var _path, _path2, _mask, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateApplicationWorkQueue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 196.73C220.715 199.181 219.192 201.525 216.848 202.362C214.504 203.2 211.729 202.527 210.07 200.539C208.411 198.552 208.292 195.773 209.569 193.638C210.846 191.503 213.412 190.325 215.855 190.822C218.679 191.393 220.711 193.856 220.74 196.734C220.752 198.056 222.805 198.056 222.793 196.734C222.76 193.334 220.637 190.329 217.456 189.143C214.274 187.956 210.632 189.003 208.53 191.573C206.428 194.143 206.038 197.994 207.828 200.917C209.618 203.84 213.014 205.269 216.331 204.633C220.071 203.914 222.752 200.49 222.789 196.73C222.801 195.408 220.748 195.408 220.736 196.73H220.74Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.085 200.038C217.913 199.281 218.782 197.184 218.024 195.355C217.267 193.527 215.17 192.658 213.342 193.416C211.513 194.173 210.644 196.27 211.402 198.099C212.159 199.927 214.256 200.796 216.085 200.038Z",
    fill: "#071A24"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_12646_22302",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.377 114.697C163.353 117.288 161.739 119.735 159.268 120.617C156.796 121.5 153.865 120.761 152.149 118.663C150.433 116.565 150.31 113.687 151.648 111.45C152.986 109.212 155.696 107.968 158.27 108.494C161.222 109.097 163.348 111.684 163.377 114.693C163.39 116.015 165.442 116.015 165.43 114.693C165.397 111.163 163.184 108.038 159.875 106.815C156.566 105.591 152.834 106.675 150.654 109.323C148.474 111.971 148.056 115.991 149.911 119.029C151.767 122.067 155.302 123.553 158.75 122.884C162.622 122.132 165.393 118.581 165.434 114.689C165.446 113.367 163.394 113.367 163.381 114.689L163.377 114.697Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.377 114.697C163.353 117.288 161.739 119.735 159.268 120.617C156.796 121.5 153.865 120.761 152.149 118.663C150.433 116.565 150.31 113.687 151.648 111.45C152.986 109.212 155.696 107.968 158.27 108.494C161.222 109.097 163.348 111.684 163.377 114.693C163.39 116.015 165.442 116.015 165.43 114.693C165.397 111.163 163.184 108.038 159.875 106.815C156.566 105.591 152.834 106.675 150.654 109.323C148.474 111.971 148.056 115.991 149.911 119.029C151.767 122.067 155.302 123.553 158.75 122.884C162.622 122.132 165.393 118.581 165.434 114.689C165.446 113.367 163.394 113.367 163.381 114.689L163.377 114.697Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.377 114.697L161.14 113.581L160.883 114.097L160.877 114.674L163.377 114.697ZM158.27 108.494L158.771 106.045L158.77 106.044L158.27 108.494ZM163.377 114.693L165.877 114.67L165.877 114.669L163.377 114.693ZM165.43 114.693L162.93 114.716V114.717L165.43 114.693ZM158.75 122.884L159.227 125.338L159.227 125.338L158.75 122.884ZM165.434 114.689L167.934 114.715L167.934 114.712L165.434 114.689ZM163.381 114.689L165.618 115.805L165.876 115.289L165.881 114.712L163.381 114.689ZM160.877 114.674C160.862 116.293 159.841 117.758 158.427 118.263L160.108 122.972C163.637 121.711 165.843 118.282 165.877 114.721L160.877 114.674ZM158.427 118.263C156.915 118.803 155.107 118.331 154.084 117.08L150.214 120.246C152.623 123.191 156.677 124.197 160.108 122.972L158.427 118.263ZM154.084 117.08C153.064 115.834 152.972 114.107 153.793 112.733L149.502 110.167C147.647 113.268 147.801 117.297 150.214 120.246L154.084 117.08ZM153.793 112.733C154.603 111.379 156.267 110.637 157.77 110.943L158.77 106.044C155.125 105.3 151.369 107.045 149.502 110.167L153.793 112.733ZM157.769 110.943C159.564 111.31 160.86 112.884 160.877 114.717L165.877 114.669C165.837 110.484 162.88 106.885 158.771 106.045L157.769 110.943ZM160.877 114.717C160.887 115.755 161.326 116.695 162.084 117.34C162.79 117.942 163.646 118.185 164.413 118.185C165.179 118.185 166.042 117.942 166.752 117.327C167.516 116.666 167.94 115.71 167.93 114.67L162.93 114.717C162.927 114.337 163.098 113.877 163.48 113.547C163.808 113.262 164.16 113.185 164.413 113.185C164.666 113.185 165.008 113.263 165.326 113.534C165.695 113.848 165.874 114.292 165.877 114.67L160.877 114.717ZM167.93 114.67C167.887 110.094 165.018 106.051 160.742 104.47L159.008 109.16C161.35 110.026 162.907 112.231 162.93 114.716L167.93 114.67ZM160.742 104.47C156.41 102.868 151.563 104.286 148.724 107.734L152.584 110.912C154.105 109.065 156.723 108.315 159.008 109.16L160.742 104.47ZM148.724 107.734C145.905 111.159 145.337 116.336 147.778 120.332L152.045 117.725C150.774 115.646 151.044 112.783 152.584 110.912L148.724 107.734ZM147.778 120.332C150.194 124.288 154.785 126.2 159.227 125.338L158.274 120.429C155.819 120.906 153.34 119.845 152.045 117.725L147.778 120.332ZM159.227 125.338C164.335 124.347 167.881 119.72 167.934 114.715L162.934 114.663C162.905 117.442 160.909 119.918 158.274 120.429L159.227 125.338ZM167.934 114.712C167.944 113.672 167.52 112.716 166.756 112.055C166.046 111.441 165.183 111.198 164.417 111.198C163.65 111.198 162.794 111.441 162.088 112.042C161.33 112.688 160.891 113.627 160.881 114.666L165.881 114.712C165.878 115.09 165.7 115.534 165.33 115.849C165.012 116.12 164.671 116.198 164.417 116.198C164.164 116.198 163.812 116.12 163.484 115.836C163.102 115.505 162.931 115.045 162.934 114.666L167.934 114.712ZM161.144 113.573L161.14 113.581L165.614 115.813L165.618 115.805L161.144 113.573Z",
    fill: "#071A24",
    mask: "url(#path-3-inside-1_12646_22302)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.219 113.802C159.712 114.993 159.147 116.359 157.956 116.852C156.765 117.345 155.4 116.78 154.906 115.589C154.413 114.398 154.979 113.032 156.169 112.539C157.36 112.046 158.726 112.611 159.219 113.802Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.764 177.446C133.408 179.09 133.408 181.756 131.764 183.4C130.119 185.044 127.454 185.044 125.809 183.4C124.165 181.756 124.165 179.09 125.809 177.446C127.454 175.801 130.119 175.801 131.764 177.446Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.269 147.598C183.672 145.895 182.616 144.188 180.913 143.786C179.209 143.383 177.502 144.439 177.1 146.142C176.698 147.846 177.753 149.553 179.457 149.955C181.16 150.357 182.867 149.302 183.269 147.598Z",
    fill: "#071A24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5534 33.3359H53.4375V43.7843H82.5534V33.3359Z",
    fill: "#4767FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.994 67.0498H82.5537",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.994 89.8071H82.5537",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.99 43.7944C267.373 56.6404 250.176 65.2619 236.348 67.056C219.615 69.2278 205.176 100.844 177.772 99.641C161.662 98.9308 153.825 76.9953 135.375 76.9953C108.357 76.9953 82.5537 112.569 82.5537 112.569H117.421",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5537 135.314H117.425H156.021H196.71",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M236.357 118.892V112.565V89.8084V67.0519V43.7944",
    fill: "#071A24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236.357 118.892V112.565V89.8084V67.0519V43.7944",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.716 118.892V112.565V89.8084V67.0519V43.7944",
    fill: "#071A24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.716 118.892V112.565V89.8084V67.0519V43.7944",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.065 43.7944V67.0519V89.8084",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.431 158.829V135.317V112.565V89.8084V67.0519V43.7944",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M272.994 43.7944V118.892H196.71V158.829H82.5537V43.7944H272.994Z",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.716 158.827V118.889H272.999",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M157.073 114.698V185.854C157.073 191.86 161.942 196.729 167.949 196.729H214.722",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M128.786 180.426V157.682C128.786 151.712 133.626 146.872 139.596 146.872H180.195",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.099 77.0128C139.099 78.4969 137.896 79.7 136.412 79.7C134.928 79.7 133.725 78.4969 133.725 77.0128C133.725 75.5288 134.928 74.3257 136.412 74.3257C137.896 74.3257 139.099 75.5288 139.099 77.0128Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M240.808 67.0491C240.808 69.5104 238.812 71.5057 236.351 71.5057C233.89 71.5057 231.895 69.5104 231.895 67.0491C231.895 64.5878 233.89 62.5925 236.351 62.5925C238.812 62.5925 240.808 64.5878 240.808 67.0491Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M279.002 199.895H228.788V210.967H279.002V199.895Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M309.709 199.895H291.817V210.967H309.709V199.895Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M214.708 189.393V170.373H342.022V223.087H214.708V204.07",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M214.708 187.771H342.022",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M240.023 187.771V223.087",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M261.37 187.771V223.087",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M300.821 187.771V223.087",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M226.849 178.903C226.849 180.122 225.861 181.11 224.642 181.11C223.424 181.11 222.436 180.122 222.436 178.903C222.436 177.685 223.424 176.697 224.642 176.697C225.861 176.697 226.849 177.685 226.849 178.903Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M237.615 178.903C237.615 180.122 236.627 181.11 235.408 181.11C234.189 181.11 233.201 180.122 233.201 178.903C233.201 177.685 234.189 176.697 235.408 176.697C236.627 176.697 237.615 177.685 237.615 178.903Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M245.854 182.36C247.763 182.36 249.311 180.812 249.311 178.903C249.311 176.994 247.763 175.447 245.854 175.447C243.945 175.447 242.397 176.994 242.397 178.903C242.397 180.812 243.945 182.36 245.854 182.36Z",
    fill: "#071A24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8189 169.676C70.8232 170.922 69.6278 172.464 68.7805 179.53C68.7301 179.942 68.1513 179.942 68.101 179.53C67.2557 172.462 66.0582 170.922 61.0625 169.676C60.7122 169.59 60.7122 169.076 61.0625 168.99C66.0582 167.744 67.2537 166.202 68.101 159.135C68.1513 158.724 68.7301 158.724 68.7805 159.135C69.6257 166.204 70.8232 167.744 75.8189 168.99C76.1691 169.076 76.1691 169.59 75.8189 169.676Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M352.451 100.284C352.748 99.0252 351.968 97.7642 350.71 97.4671C349.451 97.1701 348.19 97.9495 347.893 99.208C347.596 100.467 348.376 101.728 349.634 102.025C350.893 102.322 352.154 101.542 352.451 100.284Z",
    fill: "#071A24"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M318.092 86.8548C318.698 84.2888 317.109 81.7173 314.543 81.1113C311.975 80.5053 309.404 82.0946 308.799 84.6616C308.193 87.2275 309.782 89.799 312.348 90.4051C314.915 91.01 317.487 89.4207 318.092 86.8548Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateApplicationWorkQueue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateApplicationWorkQueue.a940d40fbf14835e2622d40c048d0359.svg";